import { apiClient } from './client'
import type { ApiResponse } from './client'

export interface OneDriveAuthStatusResult {
    ProviderEmail: string
    IsConnected: boolean
    AccessTokenExpiresUtc?: string | null
}

export interface OneDrivePickerTokenResult {
    accessToken: string
}

export interface OneDriveAuthInitiateResult {
    authorizationUrl: string
}

export const oneDriveAuthApi = {
    /** Get the OAuth authorization URL to open in popup */
    initiate: async (): Promise<ApiResponse<OneDriveAuthInitiateResult>> => {
        return apiClient.get('/api/Auth/OneDrive/Initiate')
    },

    /** Check if user has connected their OneDrive account */
    getStatus: async (): Promise<ApiResponse<OneDriveAuthStatusResult>> => {
        return apiClient.get('/api/Auth/OneDrive/Status')
    },

    /** Get a fresh access token for the OneDrive file picker */
    getPickerToken: async (): Promise<ApiResponse<OneDrivePickerTokenResult>> => {
        return apiClient.get('/api/Auth/OneDrive/PickerToken')
    },

    /** Disconnect the user's OneDrive account */
    disconnect: async (): Promise<ApiResponse<void>> => {
        return apiClient.delete('/api/Auth/OneDrive/Disconnect')
    },
}
